export const specialCharsRegex: RegExp = /^(?:[0-9A-Za-z]+)(?:[A-Za-z0-9 _-]*)$/;
export const specialCharsRegexMessage: string = `This can only contain alphanumeric characters and special characters as: '_' & '-'.`;
